import WindPowerRoundedIcon from '@mui/icons-material/WindPowerRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import WavesRoundedIcon from '@mui/icons-material/WavesRounded';
import OilBarrelRoundedIcon from '@mui/icons-material/OilBarrelRounded';
import FactoryRoundedIcon from '@mui/icons-material/FactoryRounded';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import SolarPowerRoundedIcon from '@mui/icons-material/SolarPowerRounded';
import ForestRoundedIcon from '@mui/icons-material/ForestRounded';
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';

export function getTypeColor(type) {
  switch (type) {
    case 'Vindmøller':
      return 'rgb(0, 169, 143)';
    case 'Vandkraft':
      return 'rgb(10, 81, 93)';
    case 'Olie':
      return 'rgb(51, 51, 51)';
    case 'Kul':
      return 'rgb(51, 51, 51)';
    case 'Biomasse':
      return 'rgb(0, 104, 44)';
    case 'Naturgas':
      return 'rgb(160, 193, 194)';
    case 'Solceller':
      return 'rgb(255, 212, 36)';
    case 'Affald':
      return 'rgb(252, 186, 3)';
    case 'Atomkraft':
      return 'rgb(255, 102, 0)';
    case 'Anden VE':
      return 'rgb(20, 208, 36)';
    case 'Lokal VE':
      return 'rgb(20, 208, 36)';
    case 'Komunalt VE':
      return 'rgb(119, 221, 119)';
    case 'Ukendt':
      return 'rgb(135, 135, 135)';
    default:
      return 'rgb(85, 85, 85)';

  }
}

export function getTypeIcon(type) {
  switch (type) {
    case 'Vindmøller':
      return WindPowerRoundedIcon
    case 'Vandkraft':
      return WavesRoundedIcon
    case 'Olie':
      return OilBarrelRoundedIcon
    case 'Kul':
      return FactoryRoundedIcon
    case 'Biomasse':
      return ForestRoundedIcon
    case 'Naturgas':
      return LocalFireDepartmentRoundedIcon
    case 'Solceller':
      return SolarPowerRoundedIcon
    case 'Affald':
      return DeleteRoundedIcon
    case 'Atomkraft':
      return BoltRoundedIcon
    case 'Anden VE':
      return BoltRoundedIcon
    case 'Lokal VE':
      return PlaceRoundedIcon
    case 'Komunalt VE':
      return BoltRoundedIcon
    case 'Ukendt':
      return HelpOutlineRoundedIcon
    default:
      return HelpOutlineRoundedIcon

  }
}